import { render } from "./Target.vue?vue&type=template&id=2a2ad504&scoped=true"
import script from "./Target.vue?vue&type=script&lang=js"
export * from "./Target.vue?vue&type=script&lang=js"

import "./Target.vue?vue&type=style&index=0&id=2a2ad504&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2a2ad504"

export default script